import React, { useEffect, useCallback,useRef } from "react";
import { LineChart, BarChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, AreaChart, Customized, Label } from 'recharts';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getAuditLogs } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import VizHeader from "../VizHeader/VizHeader";
import { Spin } from "antd";
import { Dropdown } from "antd"
import * as htmlToImage from 'html-to-image';
import FileSaver, { saveAs } from "file-saver";
import { useCurrentPng } from "recharts-to-png";
import SelectMonthsDurationForTrendingSearch from "../SelectMonthsDurationCMGraphs/SelectMonthsDurationForTrendingSearch";
import SelectComponentForOverview from "../SelectComponentForOverview/SelectComponentForOverview";
import ChartToggleComponent from '../../NewComponent/ChartToggleComponent/ChartToggleComponent'
import { toggleChartRegionValues } from "../../utils";
import { ReactComponent as SettingIcon } from "./../../Icons/settings.svg";




export default function AreaChartComponent(props) {
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const overViewReducer = useSelector((state) => state.cmOverview);
	const cmRootReducer = useSelector((state) => state.cmRoot)
	const userState = useSelector((state) => state.user)
	const [loading, setLoading] = React.useState(false)
	const dispatch = useDispatch()
	const { getAuditLogsDataInCMOverviewSeeker, getTotalCount } = bindActionCreators(Actions, dispatch);
	const [getAreaChartPng, { ref: areaChartRef }] = useCurrentPng();
	const [getRegionKeys, setRegionKeys] = React.useState([]);
	const [getActiveRegions, setActiveRegions] = React.useState([])
	const [getRegionData, setRegionData] = React.useState([])
	const [getTooltipPayload, setTooltipPayload] = React.useState([]);
	const [activeIndex, setActiveIndexIn] = React.useState(0);
	const [activeKeys, setActiveKeys] = React.useState(['Global'])
	const [payloadName, setPayloadName] = React.useState('Global', cmRootReducer.selecetdRoutingValue === 1 ? cmRootReducer.selectedGeoLevel.label : '')
	const [globalLabel, setGlobalLabel] = React.useState(false)
	const [countryLabel, setCountrylabel] = React.useState(false)
	const [getLegendKey, setLegendKey] = React.useState(null);
	const [activeLegendKeyRegion, setActiveLegendKeyRegion] = React.useState(null)
	const [dropdownToggle, setDropdowntoggle] = React.useState(false)
	const [activeChartType, setActiveChartType] = React.useState({ id: 1, type: 'area' });

	const dropdownRef = useRef(null);
 const selectRef = React.useRef(null);

  useEffect(() => {
	const handleClickOutside = (event) => {
	  if (!dropdownRef.current) return;

	  const isClickInsideDropdown = dropdownRef.current.contains(event.target);

	  let isClickInsideSelectDropdown = false;
	  let node = event.target;
	  while (node) {
		if (node.classList && node.classList.contains('ant-select-dropdown')) {
		  isClickInsideSelectDropdown = true;
		  break;
		}
		node = node.parentNode;
	  }

	  if (!isClickInsideDropdown && !isClickInsideSelectDropdown) {
		setDropdowntoggle(false);
	  }
	};

	if (dropdownToggle) {
	  document.addEventListener('mousedown', handleClickOutside);
	} else {
	  document.removeEventListener('mousedown', handleClickOutside);
	}
	return () => {
	  document.removeEventListener('mousedown', handleClickOutside);
	};
  }, [dropdownToggle]);


	const CustomTooltip = (active, payload, label) => {
		if (active && payload && payload.length) {
			return (
				<>
					<div>{label}</div>
				</>
			)
		}
	}

	const onClickChangeChartType = (value) => {
		setActiveChartType(value)
	}

	const handleMouseOverRegion = (data) => {
		setActiveLegendKeyRegion(data.dataKey)
	}

	const handleMouseOutRegionLegend = () => {
		setActiveLegendKeyRegion(null)
	}
	const handleMouseOverLegend = (e, data) => {
		setLegendKey(data)
	}
	const items = [
		{
			key: "1",
			label: (
				// <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
				//   1st menu item
				// </a>
				<div onClick={() => handleAreaDownload()}>Download as PNG Image</div>
			),
		},
		{
			key: "2",
			label: (
				<div onClick={() => downloadSvgAsJpeg()}>Download as JPEG Image</div>
			),
		},
		{
			key: "4",
			label: (
				<div onClick={() => handleDownloadSVG()}>Download SVG Vector image</div>
			),
		},
	];

	function downloadSvgAsJpeg() {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[3], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {

				var link = document.createElement('a');
				// link.download = 'trending-search.jpeg';
				link.download = `${expertOverview.actionValue.label.toLowerCase()}.jpeg`
				link.href = dataUrl;
				link.click();
			});

	}

	const handleDownloadSVG = () => {
		const chartContainer =
			document.getElementsByClassName("recharts-wrapper")[3];
		const chartSvg = chartContainer.querySelector("svg");
		const chartXml = new XMLSerializer().serializeToString(chartSvg);
		const svgBlob = new Blob([chartXml], {
			type: "image/svg+xml;charset=utf-8",
		});
		saveAs(svgBlob, `${expertOverview.actionValue.label.toLowerCase()}.svg`);
	};

	// const handleAreaDownload = React.useCallback(async () => {
	// 	const png = await getAreaChartPng();
	// 	if (png) {
	// 		FileSaver.saveAs(png, `${expertOverview.actionValue.label.toLowerCase()}.png`);
	// 	}
	// }, [getAreaChartPng]);

	const handleAreaDownload = () => {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[3], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {
				var link = document.createElement('a');
				link.download = `${expertOverview.actionValue.label.toLowerCase()}.png`
				link.href = dataUrl;
				link.click();
			});
	}

	const renderLegend = (props) => {
		const { payload } = props;

		return (
			<div style={{ textAlign: 'center' }}>
				{
					payload.map((entry, index) => {
						<span key={index} style={{ borderRadius: '50%', backgroundColor: `${entry.color}`, height: '20px', width: '10px' }}></span>
					})
				}
				{
					cmRootReducer.selecetdRoutingValue === 3 && payload.map((entry, index) => (
						<span onMouseOver={(e) => handleMouseOverLegend(e, payload[0].dataKey)} onClick={(e, entry) => handleLegendClickRegionGlobal(e, payload[0].dataKey)} style={{ fontWeight: 'bold', cursor: 'pointer', opacity: globalLabel ? 0.2 : 1 }} key={`item-${index}`}>{entry.value}{" "}({expertOverview.totalCount})</span>
					))
				}
				{
					cmRootReducer.selecetdRoutingValue === 1 &&
					<span style={{ fontWeight: 'bold', cursor: 'pointer', opacity: countryLabel ? 0.2 : 1 }} onClick={(e, entry) => handleLegendClickRegionGlobal(e, payload[0].dataKey)} >{cmRootReducer.selectedGeoLevel.label}({expertOverview.totalCount})</span>
				}
				{
					cmRootReducer.selecetdRoutingValue === 2 &&
					<span style={{ fontWeight: 'bold' }}>{getValuesForGeoLevels('Global')}({expertOverview.totalCount})</span>
				}
			</div>
		);
	}

	const COLORS = [
		'#009bff',
		'#00b8e6',
		'#b85cff',
		'#5e3bff',
		'#f4c900',
		'#ef7928',
		'#00c16e',
		"#7cb5ec",
		"#434348",
		"#90ed7d",
		"#f7a35c",
		"#8085e9",
		"#f15c80",
		"#e4d354",
		"#2b908f",
		"#f45b5b",
		"#91e8e1",
	];

	function getValuesForGeoLevels(val) {
		if (cmRootReducer.selecetdRoutingValue === 1) {
			val = cmRootReducer.selectedGeoLevel.label
			// setActiveKeys(val)
			return val;
		}
		// if(cmRootReducer.selecetdRoutingValue === 2 )
		// {  
		// 		if(userState.geoAttributes.attributes['2'].routingLevels.atr1 !== '' && userState.geoAttributes.attributes['2'].routingLevels.atr2 === cmRootReducer.selectedGeoLevel.label)
		// 		{
		// 				val =userState.geoAttributes.attributes['2'].routingLevels.atr1
		// 				return val;
		// 		}
		// }
		if (cmRootReducer.selecetdRoutingValue === 3) {
			val = 'Global'
			return val;
		}
	}

	const handleLegendClickRegionGlobal = (e, val) => {
		setGlobalLabel(!globalLabel)
		setCountrylabel(!countryLabel)
		setPayloadName(val)
		// const { dataKey } = val;
		// console.log(dataKey,'check')
		// if(cmRootReducer.selecetdRoutingValue === 2)
		// {
		// 	setActiveKeys(val)
		// }
		const isActive = activeKeys.includes(val);
		// If active, remove it from activeKeys; if not active, add it
		setActiveKeys((prevActiveKeys) =>
			isActive ? prevActiveKeys.filter((key) => key !== val) : [...prevActiveKeys, val]
		);
	}

	// console.log(expertOverview, 'check expert overview')

	useEffect(() => {
		if (cmRootReducer.selecetdRoutingValue !== "") {
			setLoading(true)
			getAuditLogs(expertOverview.trendingSearchDuration.value, expertOverview.actionValue.value > 1000 ? expertOverview.actionValue.id : expertOverview.actionValue.value, cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length === 0 ? "" : cmRootReducer.selectedGeoLevel.label, cmRootReducer.selectedDomainIds, overViewReducer.userTypeSelect.value, expertOverview.actionValue.value > 1000 ? expertOverview?.actionName : "").then((res) => {
				if (res === undefined) return;
				if (res.data.data !== undefined || res.data.success) {
					setLoading(false)
					// 	function getValuesForGeoLevels(val){
					// 		if (cmRootReducer.selecetdRoutingValue === 1 ) 
					// 		{
					// 				val=cmRootReducer.selectedGeoLevel.label
					// 				return val;
					// 		}
					// 		if(cmRootReducer.selecetdRoutingValue === 2 )
					// 		{  
					// 				if(userState.geoAttributes.attributes['2'].routingLevels.atr1 !== '')
					// 				{
					// 						val =userState.geoAttributes.attributes['2'].routingLevels.atr1
					// 						return val;
					// 				}
					// 		}
					// 		if(cmRootReducer.selecetdRoutingValue === 3)
					// 		{
					// 				val ='Global'
					// 				return val;
					// 		}
					// }
					getValuesForGeoLevels('Global')
					if (cmRootReducer.selecetdRoutingValue === 1) {
						setActiveKeys((prev) => {
							return [...prev, cmRootReducer.selectedGeoLevel.label]
						})
					}
					var array1 = Object.entries(res.data.data).sort().map(([date, value]) => ({ date, value }));
					if (cmRootReducer.selecetdRoutingValue === 2) {
						const formatData = (objj) => {
							let dates = Object.keys(objj).sort();
							let newArr = [];
							dates.filter((obj, index) => {
								newArr.push({ date: obj });
								Object.keys(objj[obj]).filter(ct => {
									newArr[index] = { ...newArr[index], [ct]: Object.values(objj[obj][ct]).reduce((a, b) => a + b, 0) };
								})
							})
							setRegionData(newArr)
							return newArr
						}
						formatData(res.data.data)
						setRegionKeys(Object.values(res.data.data).map((ob) => { return Object.keys(ob) }))
						setActiveRegions(Object.values(res.data.data).map((ob) => { return Object.keys(ob) })[0])
					}
					var array2 = array1.map((obj, ind) => {
						// return {date:moment(obj.date).format('MMM DD,YYYY'),Global:Object.values(obj.value[getValuesForGeoLevels('Global')]).reduce((a,b)=>a+b)}
						// return {
						// 	...(cmRootReducer?.selecetdRoutingValue === 3 && { date: moment(obj.date).format('MMM DD,YYYY'), Global: Object.values(obj.value.Global).reduce((a, b) => a + b) }),
						// 	...(cmRootReducer?.selecetdRoutingValue === 2 && { date: moment(obj.date).format('MMM DD,YYYY'), [`${cmRootReducer?.selectedGeoLevel.label}`]: Object.values(obj.value[cmRootReducer?.selectedGeoLevel.label] !== null ? obj.value[cmRootReducer.selectedGeoLevel.label] : obj.value[cmRootReducer.selectedGeoLevel.label] === 0).reduce((a, b) => a + b) }),
						// 	...(cmRootReducer?.selecetdRoutingValue === 1 && { date: moment(obj.date).format('MMM DD,YYYY'), [`${cmRootReducer?.selectedGeoLevel.label}`]: Object.values(obj.value[cmRootReducer?.selectedGeoLevel.label] !== null && obj.value[cmRootReducer.selectedGeoLevel.label]).reduce((a, b) => a + b) })
						// }

						return {
							...(cmRootReducer?.selecetdRoutingValue === 3 && { date: moment(obj.date).format('MMM DD, YYYY'), Global: Object.values(obj.value.Global).reduce((a, b) => a + b) }),
							// ...(cmRootReducer?.selecetdRoutingValue === 2 && { date: moment(obj.date).format('MMM DD,YYYY'), [`${cmRootReducer?.selectedGeoLevel.label}`]: Object.values(obj.value[getValuesForGeoLevels('Global')]||{}).reduce((a, b) => a + b,0) }),
							...(cmRootReducer?.selecetdRoutingValue === 1 && { date: moment(obj.date).format('MMM DD, YYYY'), [`${cmRootReducer?.selectedGeoLevel.label}`]: Object.values(obj.value[cmRootReducer?.selectedGeoLevel.label] || {}).reduce((a, b) => a + b, 0) })
						}
					})
					getAuditLogsDataInCMOverviewSeeker(array2)
					var array3 = array2.map((obj, ind) => {
						let obj1 = { obj: obj[getValuesForGeoLevels('Global')] }
						array2 = Object.values(obj1).reduce((a, b) => a + b, 0)
						return array2
					}).reduce((a, b) => a + b, 0)
					let localCount = array3.toLocaleString()
					getTotalCount(localCount)
				}
			})
		}
	}, [expertOverview.actionValue, expertOverview.trendingSearchDuration, cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length !== 0 && cmRootReducer.selectedGeoLevel.label, cmRootReducer.selectedDomainIds, overViewReducer.userTypeSelect])

	const renderLabelValue = (val) => {
		if (val === null) {
			return "Last Month (UTC Timezone)";
		}
		if (val === "3months") {
			return "Last 3 months";
		}
		if (val === "6months") {
			return "Last 6 months";
		}
		if (val === "12months") {
			return "Last 12 months";
		}
		if (val === "-1months") {
			return "Year-To-Date";
		}
	};

	const CustomizedTooltipForRegion = ({ active, payload, label }) => {
		if (active && payload && payload.length > 0) {
			return (
				<p className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '7px', border: `1px solid ${getTooltipPayload.length > 0 ? getTooltipPayload[0].color : `#ececec`}` }}>
					<p className="label" style={{ marginLeft: '5px' }}>{moment(label).format('MMM DD, YYYY')}</p>
					{
						getTooltipPayload.length > 0 && getTooltipPayload.map((obj, ind) => {
							if (obj.value > 0) {
								return (
									<>
										<p className="label" style={{ margin: '5px' }} key={ind}>{obj.name}:{" "}{obj.value.toLocaleString()}</p>
									</>
								)
							}
						})
					}
				</p>
			)
		}
	}

	const handleMouseEnterRegion = (useCallback((data, index) => {
		setActiveIndexIn(index);
		setTooltipPayload(data?.tooltipPayload);
	}, []));

	const handleMouseOutRegion = () => {
		setActiveIndexIn(0)
		setTooltipPayload([])
	}

	const handleLegendClickRegion = (e) => {
		const { dataKey } = e;
		const isActive = getActiveRegions.includes(dataKey);

		// If active, remove it from activeKeys; if not active, add it
		setActiveRegions((prevActiveKeys) =>
			isActive ? prevActiveKeys.filter((key) => key !== dataKey) : [...prevActiveKeys, dataKey]
		);
		// setLegendClicked(!legendClicked)
		// setLegendName(name)
	}

	const CustomizedTooltipForCountryAndGlobal = ({ active, payload, label }) => {
		if (active && payload && payload.length > 0 && payload[0].value > 0) {
			return (
				<>
					<p className="custom-tooltip" style={{ padding: '7px', backgroundColor: '#fff', border: '1px solid #ececec' }}>
						<p className="label" style={{ marginLeft: '5px' }}>{label}</p>
						{
							payload.map((obj, ind) => {
								return (
									<p className="label" style={{ color: obj.color, margin: '5px' }}>{obj.dataKey}:{" "}{obj.value.toLocaleString()}</p>
								)
							})
						}
					</p>
				</>
			)
		}
		if (active && payload && payload.length > 0 && payload[0].value === 0) {
			return (
				<p className="custom-tooltip" style={{ padding: '7px', backgroundColor: '#fff', border: '1px solid #ececec' }}>
					<p className="label">{label}</p>
				</p>
			)
		}
	}


	return (
		props.name === 'Trending Search' &&
		(
			<>
			


				{/* next line */}


				<div style={{ position: 'relative', padding: '10px', backgroundColor: '#fff', borderRadius: '8px' }}>
					{/* Header */}
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>

						{/* <VizHeader type={4} isBold={true}>Question Volume Trend</VizHeader> */}
						<span style={{ width: "100%", display: "flex", justifyContent: "center" }}>
							<VizHeader type={4} isBold={true}>{expertOverview.actionValue.label}</VizHeader>
						</span>
						<div style={{ flex: 1 }} />

						<div style={{ textAlign: 'center' }}>

						</div>
						<div style={{ position: 'absolute', right: 0, top: 0, padding: '5px' }}>
							{
								<div style={{ paddingRight: '12px' }}>
									<SettingIcon 	style={{ fontSize: '24px', cursor: 'pointer',  }} onClick={() => setDropdowntoggle(!dropdownToggle)} />
									{/* <i onClick={() => setDropdowntoggle(!dropdownToggle)} className="fa fa-gear" style={{ fontSize: '24px', cursor: 'pointer' }} /> */}
								</div>
								}
						</div>
					</div>

					{/* Chart */}
					<Spin spinning={loading}>
						{(cmRootReducer.selecetdRoutingValue === 3 || cmRootReducer.selecetdRoutingValue === 1) && (activeChartType.id === 1) &&
							(<ResponsiveContainer width={'100%'} height={400}>
								<AreaChart
									width={500}
									height={300}
									data={expertOverview.getAuditLogs}
									margin={{
										top: 5,
										right: 40,
										left: 20,
										bottom: 10,
									}}
									ref={areaChartRef}

								>
									<defs>
										<linearGradient id="AreaUv" x1="0" y1="0" x2="0" y2="1">
											<stop offset="5%" stopColor="#009bff" stopOpacity={0.8} />
											<stop offset="95%" stopColor="#009bff" stopOpacity={0.3} />
										</linearGradient>
									</defs>
									<CartesianGrid stroke="#ececec" vertical={false} />
									<XAxis angle={-45} tickMargin={2} offset={7} dy={10} dx={2} interval={"equidistantPreserveStart"} tickLine style={{ fontSize: '12px' }} dataKey="date" tickFormatter={(value) => moment(value).format('MMM-DD')}>
										<Label dy={30} dx={7} fontSize="12" fontWeight={"bold"} value={renderLabelValue(expertOverview.trendingSearchDuration.value)} />
									</XAxis>
									{/* <YAxis style={{ fontSize: '12px' }} allowDecimals={false} dataKey={cmRootReducer.selecetdRoutingValue === 3 ? 'Global' : cmRootReducer.selecetdRoutingValue === 1 ? cmRootReducer.selectedGeoLevel.label : cmRootReducer.selecetdRoutingValue === 2 ? cmRootReducer.selectedGeoLevel.label:null} axisLine={false} tickLine={false}> */}
									<YAxis style={{ fontSize: '12px' }} allowDecimals={false} dataKey={getValuesForGeoLevels('Global')} axisLine={false} tickLine={false}>
										<Label value={"Questions"} angle={-90} fontWeight="bold" dx={-22} />
									</YAxis>
									<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={false} content={<CustomizedTooltipForCountryAndGlobal />} />
									<Legend wrapperStyle={{ fontSize: '12px', padding: '7px', bottom: -5, cursor: 'pointer' }} content={renderLegend} />
									<Area hide={!activeKeys.includes(payloadName)} animationEasing="ease-in-out" fillOpacity={1} isAnimationActive type="monotone" dataKey={cmRootReducer.selecetdRoutingValue === 3 ? 'Global' : cmRootReducer.selecetdRoutingValue === 1 ? cmRootReducer.selectedGeoLevel.label : cmRootReducer.selecetdRoutingValue === 2 ? cmRootReducer.selectedGeoLevel.label : null} stroke="#009bff" fill="url(#AreaUv)" />
								</AreaChart>
							</ResponsiveContainer>)}
						{(cmRootReducer.selecetdRoutingValue === 3 || cmRootReducer.selecetdRoutingValue === 1) && (activeChartType.id === 2) &&
							(<ResponsiveContainer width={'100%'} height={400}>
								<BarChart data={expertOverview.getAuditLogs}
									height={400}>
									<CartesianGrid stroke="#ececec" vertical={false} />
									<XAxis angle={-45} tickMargin={2} offset={7} dy={10} dx={2} interval={"equidistantPreserveStart"} tickLine style={{ fontSize: '12px' }} dataKey="date" tickFormatter={(value) => moment(value).format('MMM-DD')}>
										<Label dy={30} dx={7} fontSize="12" fontWeight={"bold"} value={renderLabelValue(expertOverview.trendingSearchDuration.value)} />
									</XAxis>
									<YAxis style={{ fontSize: '12px' }} allowDecimals={false} dataKey={getValuesForGeoLevels('Global')} axisLine={false} tickLine={false}>
										<Label value={"Questions"} angle={-90} fontWeight="bold" dx={-22} />
									</YAxis>
									<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={false} content={<CustomizedTooltipForCountryAndGlobal />} />
									<Legend wrapperStyle={{ fontSize: '12px', padding: '7px', bottom: -5, cursor: 'pointer' }} content={renderLegend} />
									<Bar hide={!activeKeys.includes(payloadName)} animationEasing="ease-in-out" fillOpacity={1} isAnimationActive type="monotone" dataKey={cmRootReducer.selecetdRoutingValue === 3 ? 'Global' : cmRootReducer.selecetdRoutingValue === 1 ? cmRootReducer.selectedGeoLevel.label : cmRootReducer.selecetdRoutingValue === 2 ? cmRootReducer.selectedGeoLevel.label : null} fill="#009bff" />
								</BarChart>
							</ResponsiveContainer>)}
						{
							cmRootReducer.selecetdRoutingValue === 2 &&
							(
								<>
									<ResponsiveContainer width={'100%'} height={400}>
										<BarChart
											data={getRegionData}
											margin={{
												top: 20,
												right: 30,
												left: 20,
												bottom: 15,
											}}
											barSize={20}
											stackOffset="sign"
											ref={areaChartRef}
										>
											<CartesianGrid vertical={false} stroke="#ececec" />
											<XAxis angle={-45} dy={10} dx={2} tickMargin={5} dataKey="date" fontSize={12} tickFormatter={(value) => moment(value).format('MMM-DD')}>
												<Label dy={34} dx={7} fontWeight={'bold'} fontSize={12} value={renderLabelValue(expertOverview.trendingSearchDuration.value)} />
											</XAxis>
											<YAxis fontSize={12} axisLine={false} tickLine={false}>
												<Label value="Questions" angle={-90} dx={-22} fontWeight="bold" />
											</YAxis>
											<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={{ fill: 'transparent' }} content={<CustomizedTooltipForRegion />} />
											<Legend onMouseEnter={handleMouseOverRegion} onMouseLeave={handleMouseOutRegionLegend} wrapperStyle={{ fontSize: '12px', fontWeight: 'bold', padding: '7px', bottom: -4, cursor: 'pointer' }} onClick={handleLegendClickRegion} />
											{
												getRegionKeys[0]?.map((o, ind) =>
													<Bar hide={!getActiveRegions.includes(o)} opacity={activeLegendKeyRegion === o || activeLegendKeyRegion === null ? 1 : 0.2} onMouseOver={handleMouseEnterRegion} onMouseOut={handleMouseOutRegion} dataKey={o} stackId={"a"} fill={COLORS[ind % COLORS.length]}
													/>
												)
											}
										</BarChart>
									</ResponsiveContainer>
								</>
							)
						}
					</Spin>

					{/* Floating Settings Panel */}
					{dropdownToggle && (
						<div
						ref={dropdownRef}
						style={{
							position: 'absolute',
							top: '50px',
							right: '10px',
							width: '240px',
							backgroundColor: '#fff',
							padding: '12px',
							border: '1px solid #ccc',
							borderRadius: '8px',
							boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
							zIndex: 10
						}}>
							<div style={{ textAlign: 'end' }}>
								<i
									onClick={() => setDropdowntoggle(false)}
									className="fa fa-close"
									style={{ fontSize: '18px', cursor: 'pointer' }}
								/>
							</div>

							<div style={{ paddingBottom: '10px' }}>
								<div ref={selectRef}>
								<SelectComponentForOverview />

									</div>
							</div>
							<div style={{ paddingBottom: '10px' }}>
							<div ref={selectRef}>
								<SelectMonthsDurationForTrendingSearch />
								</div>
							</div>
							{toggleChartRegionValues(cmRootReducer.selecetdRoutingValue) &&
								<div style={{ paddingTop: '1px', textAlign: 'end' }}>
									{/* <SelectComp width={'100%'} options={[{label:'Area Chart',value:1},{label:'Bar Graph',value:2}]} onChangeFunc={onClickChangeChartType} val={activeChartType} /> */}
									<ChartToggleComponent fontSize={'24px'} type={'area'} value={activeChartType} onClickFunction={() => onClickChangeChartType({ id: 1, type: 'area' })} />
									&nbsp;&nbsp;&nbsp;
									<ChartToggleComponent fontSize={'24px'} value={activeChartType} type={'bar'} onClickFunction={() => onClickChangeChartType({ id: 2, type: 'bar' })} />
								</div>}


							<div style={{ textAlign: 'end' }}>
								<div style={{ paddingTop: '15px' }}>
									<span style={{
										color: 'rgb(92, 102, 123)',
										fontSize: '14px',
										fontFamily: 'Inter'
									}}>Download PNG</span>&nbsp;<span style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }} onClick={() => handleAreaDownload()}>
										<i className="fa fa-download" style={{ color: '#5c667b' }} />
									</span>
								</div>
								<div style={{ paddingTop: '15px' }}>
									<span style={{
										color: 'rgb(92, 102, 123)',
										fontSize: '14px',
										fontFamily: 'Inter'
									}}>Download JPEG</span>&nbsp;<span style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }} onClick={() => downloadSvgAsJpeg()}>
										<i className="fa fa-download" style={{ color: '#5c667b' }} />
									</span>
								</div>
								<div style={{ paddingTop: '15px' }}>
									<span style={{
										color: 'rgb(92, 102, 123)',
										fontSize: '14px',
										fontFamily: 'Inter'
									}}>Download SVG</span>&nbsp;<span style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }} onClick={() => handleDownloadSVG()}>
										<i className="fa fa-download" style={{ color: '#5c667b' }} />
									</span>
								</div>
							</div>
							{/* {['PNG', 'JPEG', 'SVG'].map((format, i) => {
								const handleClick = [handleAreaDownload, downloadSvgAsJpeg, handleDownloadSVG][i];
								return (
									<div key={format} style={{
										marginBottom: '10px',
										textAlign: 'end',
										color: '#5c667b',
										fontSize: '14px'
									}}>
										<span>Download {format}</span>{" "}
										<span onClick={handleClick} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}>
											<i className="fa fa-download" />
										</span>
									</div>
								);
							})} */}
						</div>
					)}
				</div>
			</>
		)
	)
}